import axios from '../../../helpers/private.axios'

export const generateDocument = ( application_id, template, templateData, bankDetails ) => {
    return axios.post(`/api/documents/templates/${template}/generate`, {
        application_id,
        template_data: templateData,
        bank_details_template: bankDetails,
    });
}